import { SERVER_API_URL, SERVER_DOMAIN } from "../constants/constants";
import axios from "axios";

const userDasboard = async () => {
  const getToken = localStorage.getItem("token");
  // console.log(page,perPage,getToken)
  const config = {
    headers: { Authorization: `Bearer ${getToken}` },
  };
  const url = `${SERVER_API_URL}/admin/admin_dashboard/getUsers`;
  const result = await axios.get(url, config);
  return result.data;
};

const getVideos = async () => {
  const getToken = localStorage.getItem("token");
  // console.log(page,perPage,getToken)
  const config = {
    headers: { Authorization: `Bearer ${getToken}` },
  };
  const url = `${SERVER_API_URL}/admin/admin_dashboard/getVideos`;
  const result = await axios.get(url, config);
  return result.data;
};

const getActiveUsersCount = async () => {
  const getToken = localStorage.getItem("token");
  const config = {
    headers: { Authorization: `Bearer ${getToken}` },
  };
  const url = `${SERVER_API_URL}/admin/admin_dashboard/active-users/count`;
  const result = await axios.get(url, config);
  return result.data;
};

const getActiveUsersList = async () => {
  const getToken = localStorage.getItem("token");
  const config = {
    headers: { Authorization: `Bearer ${getToken}` },
  };
  const url = `${SERVER_API_URL}/admin/admin_dashboard/active-users/list`;
  const result = await axios.get(url, config);
  return result.data;
};

const getUserSessions = async (
  userId,
  startDate,
  endDate,
  page = 1,
  limit = 10,
) => {
  const getToken = localStorage.getItem("token");
  const config = {
    headers: { Authorization: `Bearer ${getToken}` },
    params: { userId, startDate, endDate, page, limit },
  };
  const url = `${SERVER_API_URL}/admin/admin_dashboard/sessions`;
  const result = await axios.get(url, config);
  return result.data;
};

const getAdvancedAnalytics = async (params) => {
  const getToken = localStorage.getItem("token");
  const config = {
    headers: { Authorization: `Bearer ${getToken}` },
    params,
  };
  const url = `${SERVER_API_URL}/admin/admin_dashboard/advanced-analytics`;
  const result = await axios.get(url, config);
  return result.data;
};

const getUserProfileActivity = async (userId) => {
  const getToken = localStorage.getItem("token");
  const config = {
    headers: { Authorization: `Bearer ${getToken}` },
  };
  const url = `${SERVER_API_URL}/admin/admin_dashboard/user-profile/${userId}`;
  const result = await axios.get(url, config);
  return result.data;
};

const getAnalytics = async (period = "daily") => {
  const getToken = localStorage.getItem("token");
  const config = {
    headers: { Authorization: `Bearer ${getToken}` },
    params: { period },
  };
  const url = `${SERVER_API_URL}/admin/admin_dashboard/analytics`;
  const result = await axios.get(url, config);
  return result.data;
};

const getEngagementStats = async (params) => {
  const getToken = localStorage.getItem("token");
  const config = {
    headers: { Authorization: `Bearer ${getToken}` },
    params,
  };
  const url = `${SERVER_API_URL}/admin/admin_dashboard/engagement-stats`;
  const result = await axios.get(url, config);
  return result.data;
};

export {
  userDasboard,
  getVideos,
  getActiveUsersCount,
  getActiveUsersList,
  getUserSessions,
  getAdvancedAnalytics,
  getUserProfileActivity,
  getAnalytics,
  getEngagementStats,
};
